import React from 'react';
import $ from 'jquery';
import PreloginHome from '../../prelogin/src/PreloginHome';
import ErrorPage from '../../views/core/ErrorPage';
import { BrowserRouter as Router, Link, Redirect, Route, Switch } from "react-router-dom";
import HmAjax from '../../util/HmAjax';
import Home from '../../vendors/mindstretcher/ms_Home';
import BrowserUtil from '../../util/BrowserUtil';
import UserStorageUtil from '../../util/UserStorageUtil';
import sidebar_props from '../../model/AppConstants.js';
import Report from '../../vendors/mindstretcher/Report';


import ComponentRegistry from '../../model/ComponentRegistry.js';

class ms_PreloginHome extends PreloginHome{

 	constructor(props) {
         super(props);
         this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

         this.getHeaderLogo = this.getHeaderLogo.bind(this);
     }
     
     componentWillMount(){		
        super.componentWillMount(); 
     }

     componentDidMount() {	 
        
         super.componentDidMount();
                
              this.setFavIco(); 
			
            try{
                var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
  
                //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
              sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;
  
              if(sidebar_props.collapsed === true){
                  $('.side-navbar').addClass('shrinked');
                  $('.content-inner').addClass('active');
                  $('#toggle-btn').removeClass('active');
                  $('#toggle-btn').removeClass("goRight");
                  $('.navbar-header .brand-small').show();
                  $('.navbar-header .brand-big').hide();
              }
          }catch(e){
              console.error(e);
          }
  
            if ($(window).outerWidth() > 1183) {
              if ($('#toggle-btn').hasClass('active')) {             
                  $('#toggle-btn').addClass("goRight");
              } else {             
                  $('#toggle-btn').removeClass("goRight");
              }
          }
          if ($(window).outerWidth() < 1183) {         
              $('#toggle-btn').removeClass("goRight");
          }

        this.appendCSS("./vendors/ms_main.css");
    }

    /**
    * IMPORTANT: Please follow this way to use favIcon
    */
    setFavIco(){
         if(window.fav_ico_by_prefix && window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]){
            if(document.getElementsByName("fav_ico").length > 0){
              document.getElementsByName("fav_ico")[0].href=window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];
            }
         } 
    }
  
    toggleSideBar(){
        $('#toggle-btn').toggleClass('active');
  
          $('.side-navbar').toggleClass('shrinked');
          $('.content-inner').toggleClass('active');
          if ($(window).outerWidth() > 1183) {
              if ($('#toggle-btn').hasClass('active')) {
                  $('.navbar-header .brand-small').hide();
                  $('.navbar-header .brand-big').show();
                  $('#toggle-btn').addClass("goRight");
              } else {
                  $('.navbar-header .brand-small').show();
                  $('.navbar-header .brand-big').hide();
                  $('#toggle-btn').removeClass("goRight");
              }
          }
  
          if ($(window).outerWidth() < 1183) {
              $('.navbar-header .brand-small').show();
              $('#toggle-btn').removeClass("goRight");
          }
  
          try{
              var isCollapsed = $('.side-navbar').hasClass('shrinked');
  
  
              if(typeof isCollapsed === "boolean"){
                  this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
              }
              
  
              sidebar_props.collapsed =  $('.side-navbar').hasClass('shrinked');
              UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
          }catch(e){
              console.log(e);
          }

          try{
            var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
            console.log("isCollapsed::::",isCollapsed);
            //UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
          sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;

          if(sidebar_props.collapsed === true){
              $(".page-content .content-inner").toggleClass("fullwidth");
              $(".page-content nav.side-navbar").toggle();
              $(".page-content nav.side-navbar").toggleClass('collapsed');
          }
        }catch(e){
            console.error(e);
        }
        }
      

     getButtonName(){
        //console.log("lumos login::::",this.state.LumosloggedIn);
        if(this.state.loggedIn || this.state.LumosloggedIn || (BrowserUtil.getAuthToken() && BrowserUtil.getAuthToken().length >= 5) || (BrowserUtil.getLumosToken() && BrowserUtil.getLumosToken().length >= 5)){
            return this.rb("menu.home");
            //return this.rb("btn.label.myheymath");
        }
        return this.rb("btn.label.signin");
}

     getSwitcher(){
        return(
        <Switch>
        <Route exact path='/' component={this.Home.bind(this)}  maintainScrollPosition={true}/>
        <Route exact path='/home' component={this.Home.bind(this)}  maintainScrollPosition={true}/>
        <Route path="/landing" exact component={Home} />
        <Route path="/report" exact component={Report} />
        <Route exact path="/404" component={ErrorPage} />
        <Route component={this.getErrorPage} />
        <Redirect from='*' to='/' />
       </Switch>
        )
       }

      /*
      * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
      */       
       getHeaderLogo(){
        if(this.getUser().getSchoolPrefix() && this.getUser().getSchoolPrefix().length > 0){
          if(this.getUser().getSchoolPrefix().toLowerCase() === "ms_"){
              return(
              <img src="/img/mindstretcher/logo.png" alt="Mind Stretcher logo"/>
          )
          }else{
            return super.getHeaderLogo();  
          }
        }else{
          return super.getHeaderLogo();  
        }
       } 

       renderLoginView(){
        if(this.state.loggedIn == true){

    return(
         <div className="inlineblock">
    
    <div className="inlineblock navbar-nav">
     <li className="nav-item dropdown">
     <div className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
   
    { this.state.imageLoaded ? <img className="material-icons md-60  usericon imgprv" src={ this.state.imagePreviewUrl} /> : <i className="material-icons md-40 useraccountelement">account_circle</i> }
    </div>
    <div className="dropdown-menu">
    <div className="dropdown-item pflename">{this.UserStore.getUserName() || this.UserStore.getLoginId()}</div>
    <a className="dropdown-item" href="#" onClick={() => {this.onLogout()}}><i className="material-icons pr-16">power_settings_new</i> Sign out</a>
    </div>
    </li>
    </div>
    </div>
    );
    }
    }  
   

       getRouter(){
        var me=this;
        return(
            <Router>
        <div>
        <header className="clearfix">
    
    <nav className="nav-desktop">
    <div className="container-fluid norightpadding">
        <div className="showhidemenu">
            <a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
                <i className="material-icons">menu</i>
            </a>
        </div>
    <div className="logo"><Link to="/home" onClick={me.setPreloginClass}>{this.getHeaderLogo()}</Link></div>

    
    {( () => {
	return (<ul className="textAlignLeft"><span></span></ul>);
})()}

    <div className="r-sec">
    <a data-ga="My HeyMath Tab" className={"r-btn myheymathbtn mr-30 "+me.getMargin()} onClick={me.showLoginForm}>{me.getButtonName()}</a>
    {me.renderLoginView()}                 	
   
    </div>
    </div>
    </nav>
    
    </header>
    <div className="clearfix"></div>
    {me.getSwitcher()}
    
    </div>
    </Router>
        )
    }
    showHideLeftMenu(){
        //$(".page-content nav.side-navbar").toggle();
        $(".page-content .content-inner").toggleClass("fullwidth");
        $(".page-content nav.side-navbar").toggle();
        $(".page-content nav.side-navbar").toggleClass('collapsed');
        
        try{
            var isCollapsed = $('nav.side-navbar').hasClass('collapsed');


            if(typeof isCollapsed === "boolean"){
                this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
            } 
            

            sidebar_props.collapsed =  $('nav.side-navbar').hasClass('collapsed');
            UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);
        }catch(e){
            //console.log(e);
        }
        
        
    }

	render() {
        /*require('./ms_main.css');*/
     
        return super.render(
          this.getRouter()
        );	
	  }
	}

export default ms_PreloginHome;

ComponentRegistry.register("ms_preloginhome",ms_PreloginHome);

/*
* Also registering for the users with hm_ prefix
*/
ComponentRegistry.register("hm_preloginhome",ms_PreloginHome);


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ms_PreloginHome.js